<!--
- 快讯列表组件
- anthor: wang.y
- greatTime: 2019-08-12
-->
<template>
    <li>
        <p class="p1" v-html="filter.keyWordHighLight(dataLi.title, keyword)" @click="goEntityDetail(dataLi.uid)"></p>
        <p class="p2">
            <span v-html="filter.keyWordHighLight(dataLi.content_unsigned, keyword)"></span>
            <span v-if="dataLi.src_name" class="src_name">
                （{{dataLi.src_name}}<template v-if="dataLi.content_count > 1"> 等{{dataLi.content_count}}家媒体报道</template> ）
            </span>
        </p>
        <div class="div-img" v-if="dataLi.file_arr && dataLi.file_arr.length > 0">
            <img
                v-for="(imgItem, imgIndex) in dataLi.file_arr"
                :preview="dataLi.id"
                :key="imgIndex"
                :src="imgItem.path | logo_show"
            />
        </div>
        <div class="dec">
            <span class="time">{{dataLi.create_time | time_standard}}</span>
            <div class="collect_share">
                <i class="iconfont s active" title="取消收藏" v-if="dataLi.is_collect > 0" @click="cancelCollect('0', dataLi.id, delCollectCb)">&#xe66f;</i>
                <i class="iconfont s" title="收藏" v-else  @click="addCollect('0', dataLi.id, addCollectCb)">&#xe66f;</i>
                <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(dataLi.uid)" @on-popper-hide="haddleShareHide">
                    <i class="iconfont w">&#xe641;</i>
                    <div slot="content" class="share_cnt clear">
                      <div class="share_img"></div>
                      <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                    </div>
                </Poptip>
            </div>
        </div>
    </li>
</template>

<script>
import filter from 'js/filter'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [ collect_mixin ],
  props: ['dataLi', 'keyword'],
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    addCollectCb() {
      this.dataLi.is_collect = 1
    },
    delCollectCb() {
      this.dataLi.is_collect = 0
    },
    haddleShare(uid) {
      let share_link = this.$store.state.index2_path+ '/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯列表页分享入口'])
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    /**
    * 前往实体详情
    */
    goEntityDetail(uid) {
      if (this.$store.state.user_key) {
        const href = this.$store.state.index2_path + '/newsDetail/' + uid
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
li
  &+li
    margin-top: 30px
  .p1
    font-size: 18px
    commonColor(#E9E9EB, #333333)
    font-weight: 600
    line-height: 24px
    margin: -3px 0
    cursor: pointer
    &:hover
      color: rgba(250, 122, 80, 1)
  .p2
    font-size: 14px
    commonColor(#bcbdc1, #666666)
    line-height: 22px
    margin: 12px 0 -3px
    span.src_name
      commonColor(#797b83, #999999)
  .dec
    margin-top: 15px
    display: flex
    width: 100%
    justify-content: flex-end
    .time
      flex: auto
      line-height: 18px
      font-size: 12px
      commonColor(#BCBDC1, #AAAAAA)
      display: inline-block
      vertical-align: top
    .collect_share
      flex: 0 0 44px
  >>> .high-light
    color: rgba(250, 122, 80, 1) !important
    font-style: normal
  .div-img
    margin-top: 16px
    font-size: 0
    line-height: 1
    img
      max-width: 160px
      max-height: 80px
      cursor: pointer
    img+img
      margin-left: 20px
</style>
